/**
 * URL-based first-party (1P) vs third-party (3P) classifier for links found in
 * finalized CWR (Create With Rovo) ADF content.
 */

export function isFirstPartyLink(resourceUrl: string): boolean {
	if (!resourceUrl) {
		return false;
	}
	// Coarse URL-substring buckets — kept bug-for-bug in sync with `getLinkType` in the Confluence source of truth.
	const isJira =
		resourceUrl.includes('/jira/') ||
		resourceUrl.includes('/servicedesk/') ||
		resourceUrl.includes('/helpcenter/') ||
		resourceUrl.includes('/projects/');
	const isConfluence = resourceUrl.includes('/wiki/');
	const isBitbucket = resourceUrl.includes('bitbucket');
	const isOtherAtlassian = resourceUrl.includes('atlassian') || resourceUrl.includes('jira-dev');
	return isJira || isConfluence || isBitbucket || isOtherAtlassian;
}
